import './login.css';

import { Button, Paper, TextField, Typography } from '@material-ui/core';
import { Component, Fragment } from 'react';

import Footer from '../../components/Footer';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import LoginUnsubscribedUser from './LoginUnsubscribedUser';
import ReactGA from 'react-ga4'
import { authenticate } from '../../actions/authentication-actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { validateAuthenticateInputs } from '../../utilities/validations/authenticate-validations';
import { withSnackbar } from 'notistack';
import vcLogo from './../../assets/wwa-logo.svg';
import signupBg from './../../assets/signup-bg.png';
import withWidth from '@material-ui/core/withWidth';

const errorStyle = {
  maxWidth: '444px',
  width: '100%',
  padding: '18px',
  textAlign: 'center',
  display: 'inline-block',
  backgroundColor: 'red',
  color: 'white',
};

const errorStyleMobile = {
  width: '100%',
  padding: '12px',
  textAlign: 'center',
  display: 'inline-block',
  backgroundColor: 'red',
  color: 'white',
  marginBottom: '20px',
  borderRadius: '8px'
};

const textField = {
  height: '47px',
  borderRadius: '8px',
  backgroundColor: 'white',
};

class Login extends Component {
  constructor(props) {
    super(props);

    this.props.user.errors = {};
    this.state = {
      username: '',
      password: '',
      forgotPassword: false,
      apiValidation: false,
      goToPayment: false,
      validationErrors: {},
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit = (e) => {
    e.preventDefault();

    if (this.props.loginBlocked) {
      return;
    }

    const { valid, errors } = validateAuthenticateInputs(this.state);
    localStorage.removeItem('customer');

    if (!valid) {
      const errorMsg = errors.username || errors.password || 'Please fill in all required fields.';
      this.props.enqueueSnackbar(errorMsg, { variant: 'error' });
      this.setState({ apiValidation: false });
    } else {
      this.setState({ validationErrors: {} });
      this.props.authenticate(this.state.username, this.state.password);
      this.setState({ apiValidation: valid });
    }
  };

  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value, validationErrors: {} });
  };

  renderDesktop() {
    return (
      <Fragment>
        {this.props.match.params.logout === 'true' && (
          <div
            style={{
              position: 'absolute',
              top: '20px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 10
            }}
          >
            <Paper style={errorStyle}>Your token has expired</Paper>
          </div>
        )}
        <div className="login-wrapper-desktop flex items-center justify-center min-h-screen bg-gray-50 px-4">
          <div className="w-full max-w-6xl min-h-[550px] flex flex-row mx-auto overflow-hidden bg-white shadow-xl rounded-xl">
            <div
              className="w-2/5 min-w-0 bg-cover bg-center relative hidden sm:block"
              style={{ backgroundImage: `url(${signupBg})` }}
            >
              <div
                className="flex flex-col justify-center items-center text-center h-full text-white absolute w-full"
                style={{ gap: '13px', color: 'white' }}
              >
                <Typography
                  style={{
                    fontFamily: 'Roboto',
                    fontWeight: 500,
                    fontSize: 'clamp(14px, 1.5vw, 20px)',
                    lineHeight: '140%',
                    letterSpacing: 0,
                  }}
                >
                  Manage operations, track performance, and streamline tasks from one
                </Typography>
                <Typography
                  style={{
                    fontFamily: 'Roboto',
                    fontWeight: 700,
                    fontSize: 'clamp(24px, 3.5vw, 48px)',
                    lineHeight: '110%',
                    letterSpacing: 0,
                  }}
                >
                  Secure Admin Hub
                </Typography>
              </div>
            </div>

            <div className="flex-1 flex flex-col justify-center items-center px-4 py-8">
              <div className="w-full max-w-[480px]">
                {this.renderControls()}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  renderMobile() {
    return (
      <Fragment>
        <div className="min-h-screen w-full max-w-[100vw] overflow-x-hidden bg-white flex flex-col">

          <div className="flex-grow flex flex-col justify-center p-4">
            {this.props.match.params.logout === 'true' ? (
              <Paper style={errorStyleMobile}>Your token has expired</Paper>
            ) : null}

            <div className="w-full">
              {this.renderControls()}
            </div>
          </div>

          {/* <div className="mt-8 flex flex-col items-center justify-center">
            <h5 className='mb-2 text-sm text-gray-500'>Powered by</h5>
            <Footer />
          </div> */}
        </div>
      </Fragment>
    );
  }

  renderControls() {
    const { username, password } = this.state;
    return (
      <div className="w-full flex flex-col mx-auto max-w-[450px]">
        <div className="mb-8 flex justify-center">
          <img
            src={vcLogo}
            className="w-full max-w-[200px]"
            alt="VirtualAssistant"
          />
        </div>

        <form onSubmit={this.onSubmit} className="flex flex-col gap-[20px] w-full">
          <div className="w-full">
            <label className="block text-[#111827] text-[16px] font-['Inter'] mb-2 text-start">
              Username or email <span className="text-red-500">*</span>
            </label>
            <TextField
              id="username"
              value={username}
              onChange={this.onChange}
              placeholder="Enter your username or email"
              style={textField}
              autoComplete="off"
              size="small"
              InputProps={{
                style: {
                  borderRadius: 8,
                  borderColor: '#666'
                }
              }}
              margin="none"
              variant="outlined"
              fullWidth
            />
          </div>

          <div className="w-full">
            <label className="block text-[#111827] text-[16px] font-['Inter'] mb-2 text-start">
              Password <span className="text-red-500">*</span>
            </label>
            <TextField
              id="password"
              value={password}
              onChange={this.onChange}
              type="password"
              placeholder="Enter your password"
              style={textField}
              InputProps={{
                style: {
                  borderRadius: 8,
                  borderColor: '#666'
                }
              }}
              size="small"
              margin="none"
              variant="outlined"
              fullWidth
            />
          </div>

          <div className="text-start">
            <a href="/ForgotPassword" className="text-[#40B4E5] text-[12px] no-underline hover:underline">
              Forgot password?
            </a>
          </div>

          <Button
            type="submit"
            variant="contained"
            style={{
              width: '100%',
              height: '51px',
              borderRadius: '8px',
              padding: '16px 24px',
              background: '#10B981',
              color: 'white',
              textTransform: 'none',
              fontFamily: 'Roboto',
              fontSize: '16px',
              fontWeight: 500,
            }}
            disabled={this.props.user.loading || this.props.loginBlocked}
          >
            Login
          </Button>

          <div className="text-center mt-2">
            <p className="text-[14px] font-[Roboto] text-[#11182780]">
              Don�t have an account?{' '}
              <Link to="/Register">
                <span
                  style={{
                    fontFamily: 'Roboto',
                    fontWeight: 400,
                    fontSize: '14px',
                    textDecoration: 'underline',
                    color: '#006080',
                  }}
                >
                  Sign Up
                </span>
              </Link>
            </p>
          </div>

          <div className="flex flex-row flex-wrap justify-center mt-4 gap-2">
            <img
              className="cursor-pointer"
              src="/images/icons/appstore.svg"
              alt="Apple App Store"
              style={{ height: '43px' }}
              onClick={() =>
                window.open("https://apps.apple.com/us/app/wwa/id1515570024", "_blank")
              }
            />
            <img
              className="cursor-pointer"
              src="/images/icons/playstore.svg"
              alt="Google Play Store"
              style={{ height: '43px' }}
              onClick={() =>
                window.open("https://play.google.com/store/apps/details?id=com.wwa.worldwideassist", "_blank")
              }
            />
          </div>
        </form>
      </div>
    );
  }

  render() {
    if (this.props.user.loggedUser.username != null) {
      const loggedUser = this.props.user.loggedUser;
      const navigateToTasks =
        loggedUser.isClient ||
        loggedUser.isAssistant ||
        loggedUser.isGuest ||
        loggedUser.isAdminClient;

      if (navigateToTasks && loggedUser.userId != null) {
        this.props.history.push('/tasks/' + loggedUser.userId);
      } else {
        this.props.history.push('/');
      }
    }

    return (
      <>
        {this.props.user.subscribed === false ? (
          <>
            <LoginUnsubscribedUser />
          </>
        ) : (
          <>
            {this.props.width !== 'xs' ? (
              <>
                {this.renderDesktop()}
                {/* <Grid className='fixed bottom-[30px] right-[30px] z-20'>
                  <h5 className='my-2'>Powered by </h5>
                  <Footer />
                </Grid> */}
              </>
            ) : (
              this.renderMobile()
            )}
          </>
        )}
      </>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
    ...ownProps,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ authenticate: authenticate }, dispatch);
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(withSnackbar(withWidth()(Login)));